export default __webpack_public_path__ + "0a8419d2601cee9e9b7c42f222468927.svg";